import Smartphones from 'Events/shared/views/ReceiptBaseView/containers/Smartphones'
import Tablets from 'Events/shared/views/ReceiptBaseView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ReceiptBaseView = getCurrentDeviceView(Smartphones, Tablets)

export default ReceiptBaseView
